import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let lenisInstance: Lenis | null = null;

export function initScroll(): Lenis {
  if (lenisInstance) return lenisInstance;

  const lenis = new Lenis({
    lerp: 0.08,
    smoothWheel: true,
    touchMultiplier: 1.5,
    wheelMultiplier: 0.95,
  });

  // 1. Sync ScrollTrigger on Lenis scroll
  lenis.on('scroll', ScrollTrigger.update);

  // 2. Drive Lenis through GSAP ticker for zero-lag sync
  gsap.ticker.add((time: number) => {
    lenis.raf(time * 1000);
  });

  // 3. Prevent sudden jumps after frame drops while smoothly catching up
  gsap.ticker.lagSmoothing(500, 33);

  lenisInstance = lenis;
  return lenis;
}

export function getLenis(): Lenis | null {
  return lenisInstance;
}
